'use strict';

function LocalizationLoaderService($q, $translateStaticFilesLoader, PolopolyFSFileService) {

  function getExtra(seq, contentId, key) {
    return PolopolyFSFileService.getFile(contentId, 'locale-' + key + '.json').then(function (file) {
      return [seq, JSON.parse(file)];
    }, function () {
      return [seq, undefined];
    });
  }

  function getCopyfit(key) {
    return getExtra(1, 'atex.onecms.copyfit.locale', key).then(function (data) {
      return [data[0], {COPYFIT: data[1]}];
    });
  }

  function getStaticFiles(options) {
    return $translateStaticFilesLoader(options).then(function (data) {
      return [0, data];
    });
  }

  return function(options) {
    var promises = [];

    // Request static langage
    promises.push(getStaticFiles(options));

    // Request copyfit extras
    promises.push(getCopyfit(options.key));

    // Request product strings
    promises.push(getExtra(2, 'atex.onecms.adm.locale', options.key));

    // Request custom strings
    promises.push(getExtra(3, 'atex.onecms.custom.locale', options.key));

    // Request project overrides
    promises.push(getExtra(4, 'atex.onecms.act.locale', options.key));

    return $q.all(promises).then( function (data) {
      var length = data.length;
      var mergedData = {
        "COPYFIT": {},
        LANGUAGE_en: "English",
        LANGUAGE_it: "Italiano",
        LANGUAGE_de: "Deutsch",
        LANGUAGE_nl: "Nederlands",
        LANGUAGE_sv: "Svenska",
        LANGUAGE_es: "Español",
        LANGUAGE_dk: "Dansk",
        LANGUAGE_no: "Norsk",
        LANGUAGE_vi: "Tiếng Việt",
        LANGUAGE_tr: "Türkçe"
      };

      var orderedData = data.sort(function (a, b){return a[0] - b[0];});
      for (var i = 0; i < length; i++) {
        if (typeof orderedData[i][1] !== 'undefined') {
          $.extend(true, mergedData, orderedData[i][1]);
          $.extend(true, mergedData.COPYFIT, orderedData[i][1]['COPYFIT']);
        }
      }

      return mergedData;
    });
  };
}

angular.module('atex.art').factory('ArtLocalizationLoaderService', ['$q', '$translateStaticFilesLoader', 'PolopolyFSFileService', LocalizationLoaderService]);
